<template>
    <div class="page course-detail">
        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <div v-else>
            <video
                id="my-video"
                class="video-js vjs-default-skin vjs-big-play-centered"
                controls
                preload="none"
                x5-playsinline=""
                webkit-playsinline=""
                playsinline=""
                :poster="course.cover_img"
                x-webkit-airplay="true"
            ></video>

            <div class="course-detail-header">
                <div class="header-title">{{ course.title }}</div>
                <div class="header-author">主讲人：{{ course.doctor }} {{ course.hospital }}</div>
                <div class="header-view">
                    <div class="header-time-long">{{ course_time }}</div>
                    <div class="header-view-count">
                        <div class="header-view-count-text">{{ course.view_count }}人学习</div>
                        <div class="header-view-count-images">
                            <img :src="item" alt="" v-for="(item, index) in course.last_study_user_avatar" :key="index" />
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

            <div class="course-detail-content">
                <van-tabs :swipeable="true" :border="true" animated v-model="tab">
                    <van-tab :title="'介绍'" v-if="course.content !== '<p><br></p>'" class="course-detail-intro" :title-style="'text-align:right'">
                        <div v-html="course.content"></div>
                    </van-tab>
                    <van-tab :title="'评论'" class="course-detail-common">
                        <div class="comment">
                            <div class="comment-section" v-for="item in comment" :key="item.id">
                                <div class="comment-section-photo">
                                    <img :src="item.avatar" alt="" />
                                </div>
                                <div class="comment-section-content">
                                    <div class="comment-section-content-author" @click="reComment(item)">
                                        {{ item.nickname }}
                                        <img
                                            v-if="item.top == 1"
                                            src="/static/third/icon_top.svg"
                                            alt=""
                                            style="margin-left:4px;margin-bottom:-4px;background: #FDE0BD;border-radius: 4px"
                                        />
                                    </div>
                                    <div class="comment-section-content-detail" @click="reComment(item)">{{ item.content }}</div>
                                    <div class="comment-section-content-bottom">
                                        <div class="comment-section-content-time">{{ item.created_at }}</div>
                                        <div class="comment-section-content-point" @click="pointLikeComment(item)">
                                            <span v-if="item.isLike"><van-icon name="/static/img/course/icon_course_like_on.svg"/></span>
                                            <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg"/></span>
                                            {{ item.like_count == 0 ? '赞' : item.like_count }}
                                        </div>
                                        <div class="clear"></div>
                                        <div class="comment-section-content-children" v-if="item.children != null && item.children.length > 0">
                                            <div v-for="val in item.children">
                                                <span @click="reCommentChild(val)">{{ val.name }}</span
                                                ><span style="color: #404040" v-if="val.reply_name != ''"> 回复 </span
                                                ><span @click="reCommentChild(val)">{{ val.reply_name }}</span
                                                >：{{ val.content }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                        </div>
                    </van-tab>
                    <!-- <van-tab :title="'相关课程'" v-if="course.related != null && course.related.length > 0">
                    <div class="course-list-section" style="margin-top: 22px">
                        <van-row @click="go_detail(item)" v-for="item in course.related" :key="item.id" v-if="item.id !== course.id">
                            <div class="course-list-section-box">
                                <div class="course-list-section-left">
                                    <img class="course-list-section-left-img" :src="item.cover_img" />
                                    <img
                                        v-if="item.type == 2"
                                        class="course-list-section-left-zl"
                                        src="/static/img/icon_list_tag_column.svg"
                                        alt=""
                                    />
                                </div>
                                <div class="course-list-section-right">
                                    <div class="course-list-section-right-title">{{ item.title }}</div>
                                    <div class="course-list-section-right-author">{{ item.doctor }} · {{ item.hospital }}</div>
                                    <div class="course-list-section-right-detail">{{ item.view_count }}学习</div>
                                </div>
                            </div>
                        </van-row>
                    </div>
                </van-tab>   -->

                    <van-tab :title="'相关推荐'" :title-style="'text-align:right'">
                        <Recommend></Recommend>
                    </van-tab>
                </van-tabs>
            </div>

            <div class="course-detail-footer" v-if="tab != 2" style="padding-bottom: env(safe-area-inset-bottom);">
                <img @click="openShareData" class="course-detail-share-button" src="/static/img/btn_share.svg" alt="" />

                <div class="course-detail-column-box" v-if="course.parent != null">
                    <van-cell title-class="control-title" is-link url="/course_list" :to="'/course-column/' + course.parent.id">
                        <div slot="title"><span class="course-detail-column-box-left">所属专栏</span>{{ course.parent.title }}</div>
                    </van-cell>
                </div>

                <div class="course-detail-footer-box">
                    <div :class="'course-detail-footer-left ' + (comment_text != '' ? 'comment_in' : '')">
                        <van-field
                            round
                            left-icon="/static/img/course/icon_course_text.svg"
                            v-model="comment_text"
                            :placeholder="comment_placeholder"
                        >
                        </van-field>
                    </div>
                    <div :class="'course-detail-footer-right ' + (comment_text != '' ? 'comment_in' : '')">
                        <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
                            <van-grid-item icon="/static/img/course/icon_course_comment.svg" text="评论" @click="goComment" :badge="comment.length" />
                            <van-grid-item icon="/static/img/course/icon_course_download.svg" text="下载" @click="showDownload = true" />
                            <van-grid-item
                                @click="favorite()"
                                v-if="course.isFavorite"
                                icon="/static/img/course/icon_course_favorite_on_20.svg"
                                text="已收藏"
                            />
                            <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏" />
                        </van-grid>
                        <div class="course-detail-footer-right-btn" v-else>
                            <van-button type="danger" size="medium" @click="createComment" color="#D3172E">
                                发送
                            </van-button>
                        </div>
                    </div>
                </div>
            </div>

            <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
                <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="" />
                <div class="share-img">
                    <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="" />
                </div>
                <div class="share-cancel-btn" @click="showShareDialog = false">
                    <img src="/static/img/course/icon_course_share_close.svg" alt="" />
                </div>
            </van-dialog>

            <van-action-sheet v-model="showDownload" title="资料下载">
                <div class="download-cell">
                    <van-cell
                        title-class="download-cell__item"
                        v-for="item in course.downloads"
                        :key="item.link"
                        :title="item.name"
                        :url="item.link"
                        :icon="
                            item.type == 'pdf' ? '/static/img/course/icon_course_download_pdf.svg' : '/static/img/course/icon_course_download_pic.svg'
                        "
                        icon-size="20px"
                    >
                        <template slot="right-icon">
                            <van-icon name="/static/img/course/icon_course_download.svg" />
                        </template>
                    </van-cell>
                </div>
                <div class="van-action-sheet__footer" style="height: 30px">
                    <div class="van-action-sheet__gap"></div>
                </div>
            </van-action-sheet>

            <van-dialog class="content" v-model="needPassword" :show-confirm-button="false">
                <template slot="title">
                    本篇内容需要您输入观看密码
                </template>
                <div class="cancel_otp_code_box">
                    <div class="otpInputs">
                        <input v-enterfocus ref="otpInputs" type="number" value="12" v-model="code" @keydown.delete="changeCode" />
                        <span class="code_list">{{ code1 }}</span>
                        <span class="code_list">{{ code2 }}</span>
                        <span class="code_list">{{ code3 }}</span>
                        <span class="code_list last_code_list">{{ code4 }}</span>
                    </div>
                    <p class="error_text" :class="{ show: error }">密码错误请重试</p>
                </div>
                <div class="content-footer">
                    <van-button style="width: 50%" type="danger" round @click="checkPassword(1)" color="#D3172E">
                        点击验证
                    </van-button>
                </div>
            </van-dialog>
        </div>
        <Back></Back>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import videojs from 'video.js'
import columnSkeleton from '@/skeleton/columnSkeleton'
import Recommend from '../components/recommend.vue'
import Back from '../components/back.vue'
import verify from "../../../mixins/verify";
export default {
    name: 'course-detail',
    mixins: [verify],
    components: {
        'column-skeleton': columnSkeleton,
        Recommend,
        Back
    },
    data() {
        return {
            id: '',
            course: {},
            comment: [],
            downloads: [],
            related: [],
            value: '',
            active: '',
            tab: 0,
            comment_text: '',
            course_img_visible: true,
            loading: true,
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            showDownload: false,
            myPlayer: '',
            comment_id: 0,
            to_user_id: 0,
            comment_placeholder: '写评论',
            user_id: 0,
            course_time: ''
        }
    },
    methods: {
        fetch(scene) {
            if (scene === 'course') {
                Interface.getData('get', Interface.course.detail + '/' + this.id).then(res => {
                    let date = new Date(res.data.created_at.replace(/-/g, '\/'))

                    this.course = res.data
                    this.course_time = date.getMonth() + 1 + '月' + date.getDate() + '日' + ' | ' + res.data.duration_format + '钟'


                    if (this.course) {
                        Interface.getShareInfo(this, this.course.title, this.course.cover_img, '', 1, this.id)


                        let source_type = Interface.getUrl(window.location.href)
                        if (source_type) {
                            Interface.mFootPrint(this.id, 1,0, '', source_type, this.course.title)
                        } else {
                            Interface.mFootPrint(this.id,1,0,'',0,this.course.title)
                        }
                    }
                    Interface.getData('get', Interface.video_info + '/' + res.data.video_id).then(resp => {
                        let videoUrl
                        resp.data.PlayInfoList.PlayInfo.forEach(val => {
                            if (val.Format == 'mp4') {
                                videoUrl = val.PlayURL
                            }
                        })
                        const myPlayerOptions = {
                            bigPlayButton: true,
                            textTrackDisplay: true,
                            posterImage: true,
                            errorDisplay: true,
                            controlBar: true,
                            autoplay: false,
                            controls: true
                        }
                        this.course_img_visible = false
                        setTimeout(() => {
                            let _this = this
                            this.myPlayer = videojs('my-video', myPlayerOptions, function onPlayerReady() {
                                this.on('play', function() {
                                    //检测登录
                                    if (_this.course.need_auth === 1) {
                                        let user = localStorage.getItem('user')
                                        user = JSON.parse(user)
                                        if (user.is_complete !== 1) {
                                            this.pause()
                                            _this.$dialog
                                                .confirm({
                                                    title: '需要登录',
                                                    message: '为了方便学习课程,需要您登录认证',
                                                    confirmButtonText: '去认证'
                                                })
                                                .then(() => {
                                                    sessionStorage.setItem('back-url', _this.$route.path)
                                                    _this.$router.push({ name: 'login' })
                                                })
                                        }
                                    }
                                })
                                this.on('seeking', function() {
                                    if (_this.course.need_auth === 1) {
                                        let user = localStorage.getItem('user')
                                        user = JSON.parse(user)
                                        if (user.is_complete !== 1) {
                                            this.pause()
                                            _this.$dialog
                                                .confirm({
                                                    title: '需要登录',
                                                    message: '为了方便学习课程,需要您登录认证',
                                                    confirmButtonText: '去认证'
                                                })
                                                .then(() => {
                                                    sessionStorage.setItem('back-url', _this.$route.path)
                                                    _this.$router.push({ name: 'login' })
                                                })
                                        } else {
                                            _this.myPlayer.play()
                                        }
                                    } else {
                                        _this.myPlayer.play()
                                    }
                                })
                            })
                            this.myPlayer.src(videoUrl)
                            this.myPlayer.load(videoUrl)
                            setTimeout(() => {
                                this.loading = false
                            }, 500)
                        }, 500)
                    })
                    if (this.course.downloads != null && this.course.downloads.length > 0) {
                        this.course.downloads.forEach(item => {
                            if (item.link) {
                                item.type = item.link.substr(item.link.length - 3, 3)
                            }
                        })
                    } else {
                        this.course.downloads = []
                    }


                    if (this.course.need_password === 1 && !this.course.isPasswordAuth) {
                        this.needPassword = true
                        return
                    }
                })
                this.loading = false
            } else if (scene === 'comment') {
                let params = {
                    content_id: this.id,
                    comment_type: 1,
                    page: 1,
                    pageSize: 999
                }
                Interface.getData('get', Interface.course.comment.list, params).then(res => {
                    if (res.code == 0 && res.data.list != null) {
                        this.comment = res.data.list
                    }
                })
            } else if (scene === 'share') {
                let params = {
                    content_id: this.id,
                    type: 1
                }
                Interface.getData('get', Interface.share, params).then(res => {
                    this.share_data = res.data
                    this.htmlUrl = res.data.post_img_url
                })
            }
        },
        onClickIcon() {},
        onClickButton() {},
        reComment(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.id
        },
        reCommentChild(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.comment_id
            this.to_user_id = item.user_id
            console.log(item)
        },
        favorite() {
            Interface.getData('get', Interface.course.favorite + this.id).then(res => {
                if (res.code == 0) {
                    this.course.isFavorite = !this.course.isFavorite
                }
            })
        },
        goComment() {
            this.tab = 1
        },
        createComment() {
            this.tab = 1
            if (this.comment_text == '') {
                return
            }
            if (!Interface.checkComplete(this)){
                return;
            }
            let params = {
                content_id: this.id,
                comment_type: 1,
                content: this.comment_text
            }
            if (this.comment_id != 0) {
                params.comment_id = +this.comment_id
            }
            if (this.to_user_id != 0) {
                params.to_user_id = +this.to_user_id
            }
            Interface.getData('post', Interface.comment, params).then(res => {
                if (res.code == 0) {
                    this.$toast.success('评论成功')
                    this.comment_text = ''
                    this.comment_placeholder = '写评论'
                    this.comment_id = 0
                    this.to_user_id = 0
                    this.fetch('comment')
                    this.goComment()
                }
            })
        },
        go_detail(item) {
            if (item.type === 2) {
                this.$router.push({ name: 'course-column', params: { id: item.id } })
            } else {
                let params = {
                    content_id: this.id,
                    progress: 1,
                    type: 1
                }
                var currentTime = parseInt(this.myPlayer.currentTime())
                var duration = this.myPlayer.duration()
                params.progress = parseInt(((currentTime / duration) * 100).toFixed(0))
                Interface.getData('get', Interface.progress, params).then(res => {})
                this.tab = 0
                this.$router.push({ name: 'course-detail', params: { id: item.id } })
            }
        },

        pointLikeComment(item) {
            Interface.getData('get', Interface.pointLikeComment + item.id).then(res => {
                if (res.code == 0) {
                    item.isLike = !item.isLike
                    if (item.isLike) {
                        item.like_count += 1
                    } else {
                        item.like_count -= 1
                    }
                }
            })
        },
        openShareData() {
            this.showShareDialog = true
            Interface.mFootPrint(this.id, 1,0, 0, 2, this.course.title)
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetch('course')
        this.fetch('comment')
        Interface.footPrint(1, this.id)
        this.fetch('share')
        this.fetch('recommend')
    },
    watch: {
        async $route(to, from) {
            this.loading = true
            this.id = this.$route.params.id
            window.location.reload()
        }
    },
    destroyed() {
        if (this.myPlayer) {
            let params = {
                content_id: this.id,
                progress: 1,
                type: 1
            }
            var currentTime = parseInt(this.myPlayer.currentTime())
            var duration = parseInt(this.myPlayer.duration())
            if (isNaN(duration)) {
                params.progress = 0
            } else {
                params.progress = parseInt(((currentTime / duration) * 100).toFixed(0))
            }
            Interface.getData('get', Interface.progress, params).then(res => {})
            this.myPlayer.dispose()
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/course/detail/index.vue